import z from "zod"
import { GetWidgetConfigurationResponseData, IframeChatConfigResponseData } from "./response_data"

export const UpdateWidgetConfigurationFileSchema = z.object({
  file: z.object({
    data: z.unknown().refine((value) => Buffer.isBuffer(value), {
      message: "Expected a Buffer",
    }),
    name: z.string(),
  }),
})

export const UpdateWidgetConfigurationSchema = GetWidgetConfigurationResponseData.extend({
  displayMode: z.enum(["all", "custom"]).optional(),
})
export const UpdateIframeChatConfigSchema = IframeChatConfigResponseData

export const UploadBubbleImageFileSchema = z.object({
  file: z.object({
    data: z.unknown().refine((value) => Buffer.isBuffer(value), {
      message: "Expected a Buffer",
    }),
    name: z.string(),
    mimetype: z.string(),
  }),
})
